const dispatch = require("~/store.js").dispatch;

const server = require("~/server.js");

const events = require("./auditLoadEvents.js");

const auditLoadDispatchers = {
    LoadAudit(auditTypeName, facNumber, auditID) {
        dispatch((thunkDispatch) => {
            const loading = events.Loading.New();

            thunkDispatch(loading);

            const url = `audit/${auditTypeName}/${facNumber}/${auditID}/legacy-summary`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.LoadedLegacySurvey.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.LoadErrored.New(ex);

                    thunkDispatch(errored);
                });
        });
    }
};

module.exports = auditLoadDispatchers;


// WEBPACK FOOTER //
// ./src/events/auditLoad/legacyAuditLoadDispatchers.js